import axios from 'axios';

// En Cloudflare Pages: sin REACT_APP_BACKEND_URL se usa el mismo origen (/api → Functions)
const BASE = process.env.REACT_APP_BACKEND_URL
  ? `${process.env.REACT_APP_BACKEND_URL}/api`
  : '/api';

export const getAuthHeaders = () => {
  const token = localStorage.getItem('frap_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Preview next folio WITHOUT incrementing counter
export const previewFolio = async () => {
  const { data } = await axios.get(`${BASE}/frap/folio/preview`, { headers: getAuthHeaders() });
  return data.folio;
};

// ── FRAP CRUD ──
export const createFrap = async (formData) => {
  const { data } = await axios.post(`${BASE}/frap`, { form_data: formData }, { headers: getAuthHeaders() });
  return data;
};

export const updateFrap = async (id, formData) => {
  const { data } = await axios.put(`${BASE}/frap/${id}`, { form_data: formData }, { headers: getAuthHeaders() });
  return data;
};

export const listFraps = async () => {
  const { data } = await axios.get(`${BASE}/frap`, { headers: getAuthHeaders() });
  return data;
};

export const getFrap = async (id) => {
  const { data } = await axios.get(`${BASE}/frap/${id}`, { headers: getAuthHeaders() });
  return data;
};

export const deleteFrap = async (id) => {
  const { data } = await axios.delete(`${BASE}/frap/${id}`, { headers: getAuthHeaders() });
  return data;
};

export const updateFrapServicio = async (id, servicio) => {
  const { data } = await axios.patch(`${BASE}/frap/${id}/servicio`, { servicio }, { headers: getAuthHeaders() });
  return data;
};

export const getEstadisticas = async () => {
  const { data } = await axios.get(`${BASE}/estadisticas`, { headers: getAuthHeaders() });
  return data;
};
